import React from 'react';

export default function KakaoAuth() {
   return <div></div>;
}
